<template>
  <main>
    <section class="banner">
      <section class="container">
        <section class="left">
          <h1>高校实验室安全规范管理平台</h1>
          <strong class="line1">贴合高校实际需求 符合教育部要求</strong>
          <strong>实现规范化、常态化管理，切实保障实验室安全</strong>
        </section>
      </section>
    </section>
    <breadcrumb></breadcrumb>
    <section class="page1 bg" v-lazy:background-image="'/static/img/product/aqgf/bg1.png'">
      <article class="container flex justify-end">
        <section>
          <wl-title title='安全责任体系与安全管理制度' :isNeedDesc=false class="title"></wl-title>
          <section class="flex row" v-for="(item,idx) in page1Data" :key="item.key">
            <section class="iconBox">
              <section class="_icon " :style="`background-position: -${42*idx}px 0px;`"></section>
            </section>
            <strong>{{item.desc}}</strong>
          </section>
        </section>
      </article>
    </section>
    <section class="page2 bg" v-lazy:background-image="'/static/img/product/aqgf/bg2.png'">
      <article class="container">
        <section>
          <wl-title title='危险源全生命周期管理' :isNeedDesc=false class="title"></wl-title>
          <section class="flex row" v-for="(item,idx) in page2Data" :key="item.key">
            <section class="iconBox">
              <section class="_icon " :style="`background-position: -${42*idx}px -42px;`"></section>
            </section>
            <strong>{{item.desc}}</strong>
          </section>
        </section>
      </article>
    </section>
    <section class="page3 bg" v-lazy:background-image="'/static/img/product/aqgf/bg3.png'">
      <article class="container flex justify-end">
        <section>
          <wl-title title='项目风险评估与控制' :isNeedDesc=false class="title"></wl-title>
          <section class="flex row" v-for="(item,idx) in page3Data" :key="item.key">
            <section class="iconBox">
              <section class="_icon " :style="`background-position: -${42*idx}px -84px;`"></section>
            </section>
            <strong>{{item.desc}}</strong>
          </section>
        </section>
      </article>
    </section>
    <section class="page4 bg" v-lazy:background-image="'/static/img/product/aqgf/bg4.png'">
      <article class="container">
        <section>
          <wl-title title='实验室安全准入管理' :isNeedDesc=false class="title"></wl-title>
          <section class="flex row" v-for="(item,idx) in page4Data" :key="item.key">
            <section class="iconBox">
              <section class="_icon " :style="`background-position: -${42*idx}px -126px;`"></section>
            </section>
            <strong>{{item.desc}}</strong>
          </section>
        </section>
      </article>
    </section>
    <section class="page6">
      <article class="container">
        <wl-title title='产品优势' :isNeedDesc=false></wl-title>
        <section class="flexWrap">
          <section class="box flex" v-for="(item,idx) in page6Data" :key="item.key">
            <section class="_icon " :style="`background-position: -${72*idx}px -168px;`"></section>
            <section>
              <h3>{{item.title}}</h3>
              <p>{{item.desc}}</p>
            </section>
          </section>
        </section>
      </article>
    </section>
    <submit-page></submit-page>
  </main>
</template>

<script>
export default {
  name: 'aqgfManageSystem',
  data() {
    return {
      page1Data: [
        { key: 'aqgf-p1-1', desc: '各级组织责任体系，实时查看清晰明了' },
        { key: 'aqgf-p1-2', desc: '多方式安全责任书签订，责任到人' },
        { key: 'aqgf-p1-3', desc: '内置常用的安全管理制度，灵活自定义制度模板' },
        { key: 'aqgf-p1-4', desc: '制度实时编辑维护，多终端在线查看' },
      ],
      page2Data: [
        { key: 'aqgf-p2-1', desc: '危险源（含危化品）的采购、登记、库存、处置等全周期管理' },
        { key: 'aqgf-p2-2', desc: '建立重大危险源安全风险分布档案和数据库' },
        { key: 'aqgf-p2-3', desc: '危险源数据多维度分析统计，实时查看' },
      ],
      page3Data: [
        { key: 'aqgf-p3-1', desc: '项目登记、风险评估、整改、查看全流程管理' },
        { key: 'aqgf-p3-2', desc: '项目风险在线评估，评估通过方可开展实验' },
        { key: 'aqgf-p3-3', desc: '应急处置预案，确保安全无隐患提升应急处置能力' },
      ],
      page4Data: [
        { key: 'aqgf-p4-1', desc: '多样化的安全准入机制，实验室准入、项目准入' },
        { key: 'aqgf-p4-2', desc: '全方位的准入考核，灵活设置准入配置' },
        { key: 'aqgf-p4-3', desc: '多项达标即可获得准入，严格落实准入机制' },
      ],
      page6Data: [
        { key: 'aqgf-p5-1', title: '贴合实际符合要求', desc: '满足教育部实验室安全分级分类管理机制要求，贴合\n高校实际需求' },
        { key: 'aqgf-p5-2', title: '完善的完全规范管理', desc: '安全责任体系、安全管理制度、教育培训、安全准入、\n条件保障，危险源等全方位安全规范管理' },
        { key: 'aqgf-p5-3', title: '拓展性强支持二开', desc: '能快速拓展实验室综合管理平台其他模块，支持二次\n开发' },
        { key: 'aqgf-p5-4', title: '贴心服务', desc: '专业的服务支持团队，快速响应，7*24小时高效快速\n服务每位用户' },
      ],
    }
  },
  methods: {
  }
}
</script>

<style lang='scss' scoped>
._icon {
  background: url("/static/img/product/aqgf/icon.png");
}
main {
  background: #fbfbff;
  text-align: left;
}
.title {
  ::v-deep h2 {
    font-size: 36px;
    font-weight: bold;
    color: #262626;
    line-height: 36px;
    padding-bottom: 20px;
  }
}
strong {
  font-size: 18px;
  color: #262626;
  font-weight: 500;
  line-height: 27px;
  // line-height: 72px;
}
.iconBox {
  width: 72px;
  height: 72px;
  background: #f1f5ff;
  border-radius: 14px;
  text-align: center;
  padding-top: 15px;
  margin-right: 16px;
  ._icon {
    width: 42px;
    height: 42px;
    display: inline-block;
  }
}
.row {
  padding: 11px;
  width: 560px;
  border-radius: 14px;
  align-items: center;
  &:hover {
    background: #f3f7ff;
    .iconBox {
      background: #ffffff;
    }
  }
}
.banner {
  height: 540px;
  background: url("/static/img/product/aqgf/banner.png") center/cover;
  .left {
    width: 580px;
    padding-top: 199px;
    text-align: left;
    h1 {
      font-size: 40px;
      line-height: 40px;
      padding-bottom: 46px;
    }
    strong {
      font-size: 24px;
      color: #6d6d6d;
      line-height: 24px;
      white-space: pre-line;
    }
    .line1 {
      color: #308dff;
      padding-bottom: 25px;
    }
  }
}
.page1 {
  padding-top: 78px;
  height: 587px;
}
.page2 {
  padding-top: 119px;
  height: 587px;
}
.page3 {
  padding-top: 140px;
  height: 587px;
}
.page4 {
  padding-top: 98px;
  height: 587px;
}
.page6 {
  height: 809px;
  padding-top: 136px;
  ::v-deep h2 {
    text-align: center;
    padding-bottom: 65px;
  }
  .box {
    width: 615px;
    height: 200px;
    background: #ffffff;
    box-shadow: 0px 8px 20px 1px rgba(164, 183, 207, 0.16);
    border-radius: 14px;
    padding-left: 37px;
    margin-bottom: 32px;
    align-items: center;
    &:nth-child(2n) {
      padding-left: 32px;
    }
    ._icon {
      width: 72px;
      height: 72px;
      display: inline-block;
      transition: all 0.2s linear;
    }
    section {
      margin-left: 16px;
    }
    h3 {
      font-size: 24px;
      font-weight: 500;
      color: #262626;
      line-height: 24px;
    }
    p {
      font-size: 20px;
      color: #8e8e8e;
      line-height: 30px;
      padding-top: 15px;
      white-space: pre-line;
    }
    &:hover {
      ._icon {
        transform: translateY(-10px);
      }
    }
  }
}
</style>
